const angular = require('angular');

module.exports = function () {
    return {
        restrict: 'A',
        require: '?ngModel',
        link(scope, element, attrs, ngModelCtrl) {
            if (!ngModelCtrl) {
                return;
            }

            scope.validate = function (model, postcode) {
                if (postcode.length === 0) {
                    ngModelCtrl.$setValidity('required', false);
                } else if (postcode.length > 0) {
                    ngModelCtrl.$setValidity('required', true);
                }
                if (postcode.length > 0 && postcode.length < 4) {
                    ngModelCtrl.$setValidity('invalid', false);
                } else if (postcode.length === 0 || postcode.length === 4) {
                    ngModelCtrl.$setValidity('invalid', true);
                }
            };

            ngModelCtrl.$parsers.push((val) => {
                if (angular.isUndefined(val)) {
                    val = '';
                }
                let clean = val.replace(/[^0-9]+/g, '');

                if (clean.length > 4) {
                    clean = clean.substring(0, 4);
                }

                if (val !== clean) {
                    ngModelCtrl.$setViewValue(clean);
                    ngModelCtrl.$render();
                }

                scope.validate(ngModelCtrl, clean);
                return clean;
            });

            element.bind('keypress', (event) => {
                if (event.keyCode === 32) {
                    event.preventDefault();
                }
            });
        },
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/postcode/post-code.directive.js